import React, { useContext } from 'react';
import { Row, Col, Divider, Button, Card, Spin } from 'antd';
import { GoogleOutlined } from '@ant-design/icons';
import { GoogleLogin } from 'react-google-login';
import { gapi } from 'gapi-script';
import { loadAuth2 } from 'gapi-script';
import { UserContext } from '../Reducers/UserContext';
import { useSecureConfigContext } from '../SecureConfig/SecureConfigProvider';
import { authorizeGoogle } from '../../api';
import Auth0Login from '../Auth0Login/Auth0Login';

const SalesforceLogin = () => {
    const { isLoggedIn, setLogger } = useContext(UserContext);
    const { getGoogleClientId, hasSecureConfig, loading } = useSecureConfigContext();

    const now = new Date();

    const clientId = getGoogleClientId() || '';
    const shouldDisableButtons = loading || !hasSecureConfig();

    if (!hasSecureConfig()) {
        console.warn('Secure configuration not available for Google Client ID');
    }

    if (clientId) {
        loadAuth2(gapi, clientId, '');
    }

    const onSuccess = async (res) => {
        const data = await authorizeGoogle({
            usr: res.profileObj.email,
            res: res.profileObj,
        });

        setLogger({
            active: true,
            user: {
                role: 'guest',
                name: res.profileObj.email,
                subscriber_id: data['usr_exst']['id'],
                entry: now,
                auth0: false,
                auth0LogOut: false,
            },
        });
    };

    const onFailure = (err) => {
        console.log('failed', err);
    };

    return (
        <div>
            {!isLoggedIn['active'] ? (
                <div>
                    <br />
                    <Row>
                        <Col span={6}></Col>
                        <Col span={6}>
                            <div style={{ backgroundColor: 'white' }}>
                                <img src="/img/netskope-logo-black.svg" alt="" width="280px" height="52x" />
                            </div>
                        </Col>
                    </Row>
                    <Divider style={{ padding: '0px' }} />
                    <Row>
                        <Col span={9}></Col>
                        <div className="site-card-border-less-wrapper">
                            <Card
                                title="Sign in"
                                bordered={true}
                                style={{ width: 450, borderRadius: '20px', borderWidth: '8px' }}
                                headStyle={{
                                    backgroundColor: '#F0F8FF',
                                    border: 0,
                                    color: 'grey',
                                }}
                            >
                                <div style={{ padding: '8px 0' }}>
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Auth0Login disabled={shouldDisableButtons} />
                                            <div
                                                style={{
                                                    textAlign: 'center',
                                                    color: '#888',
                                                    fontSize: '12px',
                                                    marginTop: '6px',
                                                }}
                                            >
                                                Migrated users
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            {clientId && !shouldDisableButtons ? (
                                                <GoogleLogin
                                                    clientId={clientId}
                                                    render={(renderProps) => (
                                                        <Button
                                                            type="primary"
                                                            icon={<GoogleOutlined />}
                                                            onClick={renderProps.onClick}
                                                            block
                                                        >
                                                            Login with Google
                                                        </Button>
                                                    )}
                                                    buttonText="NS Employee Login"
                                                    onSuccess={onSuccess}
                                                    onFailure={onFailure}
                                                    cookiePolicy={'single_host_origin'}
                                                />
                                            ) : shouldDisableButtons ? (
                                                <div style={{ textAlign: 'center', marginTop: '4px' }}>
                                                    <Spin size="small" />
                                                    <span
                                                        style={{
                                                            marginLeft: '8px',
                                                            color: '#999',
                                                            fontStyle: 'italic',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        🔄 Google
                                                    </span>
                                                </div>
                                            ) : (
                                                <div
                                                    style={{
                                                        color: '#666',
                                                        fontStyle: 'italic',
                                                        fontSize: '12px',
                                                        textAlign: 'center',
                                                        marginTop: '4px',
                                                    }}
                                                >
                                                    Loading...
                                                </div>
                                            )}
                                            <div
                                                style={{
                                                    textAlign: 'center',
                                                    color: '#888',
                                                    fontSize: '12px',
                                                    marginTop: '6px',
                                                }}
                                            >
                                                Netskope employees
                                            </div>
                                        </Col>
                                    </Row>

                                    <div style={{ textAlign: 'center', marginTop: '16px' }}>
                                        <span style={{ color: '#888', fontSize: '13px' }}>
                                            Don't have an account?{' '}
                                            <a
                                                href="https://support.netskope.com/s/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Sign Up
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </Row>
                </div>
            ) : null}
        </div>
    );
};

export default SalesforceLogin;
